import { Course } from '../types';

export const mockCourses: Course[] = [
  {
    id: 'course-1',
    name: 'Mathematics',
    code: 'MATH101',
    description: 'Core mathematics curriculum',
    department: 'Mathematics',
    isActive: true,
  },
  {
    id: 'course-2',
    name: 'English Language Arts',
    code: 'ELA101',
    description: 'English language and literature',
    department: 'English',
    isActive: true,
  },
  {
    id: 'course-3',
    name: 'Science',
    code: 'SCI101',
    description: 'General science curriculum',
    department: 'Science',
    isActive: true,
  },
  {
    id: 'course-4',
    name: 'Social Studies',
    code: 'SS101',
    description: 'History and social sciences',
    department: 'Social Studies',
    isActive: true,
  },
  {
    id: 'course-5',
    name: 'Physical Education',
    code: 'PE101',
    description: 'Physical education and health',
    department: 'Physical Education',
    isActive: true,
  },
  {
    id: 'course-6',
    name: 'Art',
    code: 'ART101',
    description: 'Visual arts and creative expression',
    department: 'Arts',
    isActive: true,
  },
  {
    id: 'course-7',
    name: 'Music',
    code: 'MUS101',
    description: 'Music theory and performance',
    department: 'Arts',
    isActive: true,
  },
  {
    id: 'course-8',
    name: 'Computer Science',
    code: 'CS101',
    description: 'Introduction to programming and technology',
    department: 'Technology',
    isActive: true,
  },
  {
    id: 'course-9',
    name: 'Spanish',
    code: 'SPAN101',
    description: 'Spanish language learning',
    department: 'World Languages',
    isActive: true,
  },
  {
    id: 'course-10',
    name: 'French',
    code: 'FREN101',
    description: 'French language learning',
    department: 'World Languages',
    isActive: true,
  },
];
